
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/HomeQRs",
      function () {
        return require("private-next-pages/HomeQRs/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/HomeQRs"])
      });
    }
  